const API_FETCH_USER_SUCCESS = "API_FETCH_USER_SUCCESS";
const API_FETCH_USER = "API_FETCH_USER";
const API_FETCH_MENU_SUCCESS = "API_FETCH_MENU_SUCCESS";
const API_FETCH_MENU = "API_FETCH_MENU";
const ADD_ITEM_MENU = "ADD_ITEM_MENU";
const ADD_ITEM_MENU_SUCCESS = "ADD_ITEM_MENU_SUCCESS";
const REMOVE_ITEM_MENU = "REMOVE_ITEM_MENU";
const REMOVE_ITEM_MENU_SUCCESS = "REMOVE_ITEM_MENU_SUCCESS";
const GENERATE_LOGIN_OTP = "GENERATE_LOGIN_OTP";
const GENERATE_LOGIN_OTP_SUCCESS = "GENERATE_LOGIN_OTP_SUCCESS";
const SEND_LOGIN_OTP = "SEND_LOGIN_OTP";
const REGISTER_USER = "REGISTER_USER";
const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
const SEND_LOGIN_OTP_SUCCESS = "SEND_LOGIN_OTP_SUCCESS";
const CLEAR_REDIRECT = "CLEAR_REDIRECT";
const LOGIN_GUEST_USER = "LOGIN_GUEST_USER";
const SET_SELECTED_CATEGORY = "SET_SELECTED_CATEGORY";
const PLACE_ORDER = "PLACE_ORDER";
const PLACE_ORDER_SUCCESS = "PLACE_ORDER_SUCCESS";
const CLEAR_CART = "CLEAR_CART";
const FETCH_REORDER_SUCCESS = "FETCH_REORDER_SUCCESS";
const FETCH_REORDER_REQUEST = "FETCH_REORDER_REQUEST";
const ADD_TO_CART_FROM_REORDER = "ADD_TO_CART_FROM_REORDER";
const FETCH_BILL_REQUEST = "FETCH_BILL_REQUEST";
const FETCH_BILL_SUCCESS = "FETCH_BILL_SUCCESS";
const SUBMIT_PAYMENT = "SUBMIT_PAYMENT";
const START_SIGNALR = "START_SIGNALR";
const PAYMENT_VERIFIED = "PAYMENT_VERIFIED";
const SEND_WAITER_REQUEST = "SEND_WAITER_REQUEST";
const SEND_WAITER_REQUEST_SUCCESS = "SEND_WAITER_REQUEST_SUCCESS";
const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
const ADD_NOTE = "ADD_NOTE";

export {
  ADD_NOTE,
  LOGOUT_SUCCESS,
  SEND_WAITER_REQUEST,
  SEND_WAITER_REQUEST_SUCCESS,
  START_SIGNALR,
  PAYMENT_VERIFIED,
  API_FETCH_MENU_SUCCESS,
  API_FETCH_MENU,
  API_FETCH_USER_SUCCESS,
  API_FETCH_USER,
  ADD_ITEM_MENU,
  ADD_ITEM_MENU_SUCCESS,
  REMOVE_ITEM_MENU,
  REMOVE_ITEM_MENU_SUCCESS,
  GENERATE_LOGIN_OTP,
  SEND_LOGIN_OTP,
  SEND_LOGIN_OTP_SUCCESS,
  CLEAR_REDIRECT,
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  GENERATE_LOGIN_OTP_SUCCESS,
  LOGIN_GUEST_USER,
  SET_SELECTED_CATEGORY,
  PLACE_ORDER,
  PLACE_ORDER_SUCCESS,
  CLEAR_CART,
  FETCH_REORDER_REQUEST,
  FETCH_REORDER_SUCCESS,
  ADD_TO_CART_FROM_REORDER,
  FETCH_BILL_REQUEST,
  FETCH_BILL_SUCCESS,
  SUBMIT_PAYMENT,
};
